export const personalInformationData = (object) => {
  const excludedFields = [
    "id",
    "acl",
    "createdAt",
    "updatedAt",
    "affiliate",
    "branch",
    "roles",
    "registrationStatus",
  ];

  const newObjectArray = Object.keys(object)
    .map((key) => {
      if (excludedFields.includes(key)) return null;

      return { label: key, value: object[key] };
    })
    .filter((item) => item !== null);

  return newObjectArray;
};
